import React from "react";
import { Row, Col, Button, Card } from "react-materialize";
import { Link } from "react-router-dom";
import $ from "jquery";
import Page from "../Page";
import { trans } from "../Lang";
import { QueryParam, API_CONTACT, BASE_URL } from "../Util";

class Contacts extends Page {
  constructor(props) {
    super(props);

    this.state = {
      title: "Kontak",
      content: null,
    };

    this.scrollToTop();
  }

  componentDidMount() {
    this.handleLoadData();
  }

  handleLoadData() {
    $.getJSON(API_CONTACT).then((data) => {
      const { title, content } = data.payload;
      this.setState({ title, content });
    });
  }

  // componentDidMount = () => {

  // }

  render() {
    const { title, content } = this.state;

    return (
      <div>
        <div className="bg-blue">
          <Row className="container text-center pad-s">
            <h3 className="font-white page-title">{title}</h3>
          </Row>
        </div>

        <div className="container center">
          <div className="row">
            <div className="col s12 m6 offset-m3">
              <div dangerouslySetInnerHTML={{ __html: content }} />
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default Contacts;



// WEBPACK FOOTER //
// ./src/components/Contacts/Contacts.js